export class Importe{
    public terminosCondiciones: boolean = false;
    public vehiculoParticular: boolean = false;
    public vehiculoSiniestro: boolean = false;
    constructor(){}
  }